module.exports = __webpack_public_path__ + "assets/img/light-tip-success.cf84375d.svg";